export const FIELD_KIND = { STATIC: 'static', CUSTOM: 'custom' } as const;
export type FieldKind = (typeof FIELD_KIND)[keyof typeof FIELD_KIND];

export const SECTION_ID = {
  OFFER_DETAILS: 'offer_details',
  ADDITIONAL_COMPENSATION: 'additional_compensation',
  CANDIDATE_DETAILS: 'candidate_details',
  JOB_DETAILS: 'job_details',
  CUSTOM: 'custom',
} as const;
export type SectionId = (typeof SECTION_ID)[keyof typeof SECTION_ID];

// Canonical section order — mirrors BE Ats::FormTemplate::OfferFieldComposer::SECTION_IDX.
export const SECTION_ORDER: readonly SectionId[] = [
  SECTION_ID.OFFER_DETAILS,
  SECTION_ID.ADDITIONAL_COMPENSATION,
  SECTION_ID.CANDIDATE_DETAILS,
  SECTION_ID.JOB_DETAILS,
  SECTION_ID.CUSTOM,
];
